import { useMutation } from 'react-query';

import { unarchiveProject } from 'shared/api/projects/http';

const useMutateUnarchiveProject = (options = undefined) => useMutation((id) => unarchiveProject(id), options);

export default useMutateUnarchiveProject;
